import { useState } from 'react';
import Sheet from '../../components/Sheet.jsx';
import Button from '../../components/Button.jsx';
import { chooseDeviceSettings, chooseSharedSettings, useSettingsJoin } from '../../sync/settingsSync.js';
import styles from './Settings.module.scss';

export default function SettingsJoinPrompt() {
  const open = useSettingsJoin((s) => s.open);
  const [busy, setBusy] = useState(false);

  const run = async (fn) => {
    if (busy) return;
    setBusy(true);
    try {
      await fn();
    } finally {
      setBusy(false);
    }
  };

  return (
    <Sheet
      open={open}
      dismissible={false}
      title="Use your shared settings?"
      subtitle="Your other devices already share one set of app settings."
    >
      <p className={styles.shareLead}>
        Appearance, layout, and study settings can stay in sync with those devices. Or this device can keep the settings
        it already has, and they will not change your other devices.
      </p>
      <div className={styles.shareActions}>
        <Button variant="primary" block disabled={busy} onClick={() => run(chooseSharedSettings)}>
          Use shared settings
        </Button>
        <Button block disabled={busy} onClick={() => run(chooseDeviceSettings)}>
          Keep this device’s settings
        </Button>
      </div>
    </Sheet>
  );
}
